export const RETAIL_DRAFT_TOTAL_STEPS = 8;

/** Canonical step index for each retail wizard step (resume / navigation). */
export const RETAIL_DRAFT_STEP_INDEX: Record<string, number> = {
  vehicle_identification: 1,
  vehicle_bodywork: 2,
  client: 3,
  leasing_financing: 4,
  additional_informations: 5,
  selling_type_retail: 6,
  "vehicle_trade-in": 7,
  ctm_summary_validation: 8,
};

export function resolveRetailDraftStepIndex(
  stepId: string,
): number | undefined {
  return RETAIL_DRAFT_STEP_INDEX[stepId];
}

export function clampRetailDraftStepIndex(index: number): number {
  return Math.min(Math.max(index, 1), RETAIL_DRAFT_TOTAL_STEPS);
}

export function resolveRetailDraftStepIndexAfterSave(
  completedStepId: string,
): number | undefined {
  const current = RETAIL_DRAFT_STEP_INDEX[completedStepId];
  if (current === undefined) {
    return undefined;
  }

  return clampRetailDraftStepIndex(current + 1);
}
